import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';
import { EDIT_SIP_DOMAIN_DRAWER } from '../../../../constants';
import { StyledDrawer } from './styled';
import EditDomainForm from './EditDomainForm';

const EditDomainDrawer = () => {
    const connectedProps = useConnectModal(
        EDIT_SIP_DOMAIN_DRAWER,
        { size: 'small', slideFrom: 'right' },
    );
    const [, closeDrawer] = useOpenModal(EDIT_SIP_DOMAIN_DRAWER);
    const {
        agentId,
        initialValues,
        onSubmit,
        ...drawerProps
    } = connectedProps;

    return (
        <StyledDrawer
            {...drawerProps}
            onRequestClose={closeDrawer}
        >
            <EditDomainForm
                agentId={agentId as string}
                initialValues={initialValues as Record<string, unknown>}
                onRequestClose={closeDrawer}
                onSubmit={onSubmit as (values: { workflowId: string }) => Promise<void>}
            />
        </StyledDrawer>
    );
};

export default EditDomainDrawer;
